import { render, staticRenderFns } from "./ButtonCommon.vue?vue&type=template&id=827c9424&scoped=true&"
import script from "./ButtonCommon.vue?vue&type=script&lang=js&"
export * from "./ButtonCommon.vue?vue&type=script&lang=js&"
import style0 from "./ButtonCommon.vue?vue&type=style&index=0&id=827c9424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827c9424",
  null
  
)

export default component.exports